import React, {useRef, useEffect} from 'react';
import LandingFooter from './LandingFooter';
import Banner from './Banner';
import './LandingStyles.css'
import { useSelector } from 'react-redux';
import BottomComponent from './BottomComponent';
import Concerts from './Concerts';
import NewPlaylists from './NewPlaylists';
import Genres from './Genres';
import EssentialClassics from './EssentialClassics';
import { useNavigate } from 'react-router-dom';
import GroupsComponent from '../PlaylistGroups/GroupsComponent';


const LandingPage = (props) => {


   const navigate = useNavigate()


   const {user} = useSelector(state=>state.user)


   const landingRef = useRef()

   const slideClickHandler = (item) => {
       localStorage.setItem('playlist_id', item.id)
       localStorage.setItem('video_id', item.video.id)
       localStorage.setItem('group_id', 5)
       localStorage.setItem("path", encodeURI(`/home?g=${5}&p=${item.id}&v=${item.video.id}`))
       if(props.user) {
           navigate(encodeURI(`/home?g=${5}&p=${item.id}&v=${item.video.id}`,  {replace: false} ))
       } else {
           navigate('/login')
       }
       }

    let group_id = Number(localStorage.getItem('group_id')) || 4;

   useEffect(() => {

       const handleScroll = () => {
           sessionStorage.setItem("landing-scroll", window.scrollY);;
       };

       window.addEventListener("scroll", handleScroll);
       return () => window.removeEventListener("scroll", handleScroll);
   }, []);



   useEffect(() => {
       localStorage.setItem("path", '/')
       const savedPosition = sessionStorage.getItem("landing-scroll");
       if (savedPosition) {
           setTimeout(() => {
           window.scrollTo({
               top: parseInt(savedPosition, 10),
               behavior: "auto",
           });
           }, 100); // Adjust delay if needed
       }
       }, []);

    const onGroupClick = (group) => {
        props.setActiveGroup(group);
        localStorage.setItem('group_id', group.id)
        props.groupsRef.current && props.groupsRef.current.scrollIntoView({ behavior: "smooth" })

    }


    const onGroupPlaylistClick = (playlist) => {
        localStorage.setItem('video_id', playlist.video_id)
        localStorage.setItem('playlist_id', playlist.id)
        localStorage.setItem('group_id', props.activeGroup.id)
        if(props.user) {
            navigate(encodeURI(`/home?g=${props.activeGroup.id}&p=${playlist.id}&v=${playlist.video_id}`))
        } else {
            localStorage.setItem("path", encodeURI(`/home?g=${props.activeGroup.id}&p=${playlist.id}&v=${playlist.video_id}`))
            navigate('/login')
        }
    }

    return (
        <div className='d-flex flex-column align-items-center bg-$backcolor'>
            <div id = 'landing_body'
                ref = {landingRef}
            >
                <Banner
                    user = {user}
                />
                <div style={{ marginTop:'-15vw', zIndex:2, position:'relative'}}>
                    <NewPlaylists
                        title = {'New Playlists'}
                        newPlaylistsRef = {props.newPlaylistsRef}
                    />
                    <EssentialClassics
                        user = {user}
                    />
                    <Concerts
                        user = {user}
                        slidesToShow = {1}
                        slideClickHandler = {slideClickHandler}
                    />

                    <Genres
                        user = {user}
                        setFilterList={props.setFilterList}
                        setActiveComponent={props.setActiveComponent}
                    />
                    {
                        group_id &&
                        <GroupsComponent
                            activeGroup={props.activeGroup}
                            setActiveGroup={props.setActiveGroup}
                            onGroupClick={onGroupClick}
                            slideClickHandler={onGroupPlaylistClick}
                            group_id={group_id}
                            groupsRef={ props.groupsRef}
                        />
                    }

                    <BottomComponent
                        user = {user}
                        setFilterList={props.setFilterList}
                        setActiveComponent={props.setActiveComponent}
                    />
                    <LandingFooter/>
                </div>
            </div>
        </div>

    );
}


export default LandingPage;